<template>
  <div class="container text-center py-5">
    <div v-show="isLoading" class="loader-container">
      <div ref="lottieLoader" class="lottie-animation"></div>
      <p class="loader-text">Loading...</p>
    </div>

    <!-- Animated SVG lines image -->
    <img ref="decorativeSvgRef" src="@/assets/ornamiento.png" alt="SVG Decoration" class="decorative-svg">

    <div ref="bienvenidaRef" class="card shadow-lg p-4 bg-light upload-container">
      <div class="mb-3">
        <img src="@/assets/camara.png" alt="Welcome" class="img-fluid gif-pequeno">
      </div>

      <h4 class="titulo">Photo Album</h4><br>

      <p class="text-muted">Upload your event pictures here</p>

      <!-- Attractive photo upload area -->
      <label for="inputFile" class="upload-area">
        <i class="fas fa-camera-retro upload-icon"></i>
        <span class="custom-file-upload"> Select Images</span>
      </label>

      <input 
        id="inputFile"
        ref="fileInput"
        type="file"
        name="photos"
        class="file-input"
        accept="image/*"
        multiple
        @change="validateFiles"
      >

      <p v-if="errorMessage" class="text-danger">{{ errorMessage }}</p>

      <!-- Image preview section -->
      <div v-if="previewImages.length > 0" class="preview-container">
        <h5 class="text-secondary mt-3">Preview:</h5>
        <div class="preview-grid">
          <div v-for="(src, index) in previewImages" :key="index" class="preview-item">
            <img :src="src" alt="Preview" class="preview-image">
            <button class="delete-btn" @click="removeImage(index)">
              <i class="fas fa-trash-alt"></i>
            </button>
          </div>
        </div>
      </div>

      <!-- Custom upload button -->
      <button class="upload-btn" @click="confirmUpload">
        <i class="fas fa-cloud-upload-alt"></i> Upload Photos
      </button>
      <p class="text-muted mt-3">Don’t forget to click "Upload Photos" after reviewing your images.</p>

      <p v-if="photoUploaded" class="mensaje-gracias">Thank you for sharing your photos with us!</p>
    </div>
  </div>
</template>

<script>
import { ref,watch } from 'vue';
import axios from 'axios';
import baseUrl from '@/api';
import Swal from 'sweetalert2';
import lottie from 'lottie-web';
import heartAnimation from '@/assets/heart.json';

export default {
  name: 'hashtag-etiqueta',
  props: {
    idInvitado: {
      type: Number,
      required: true,
      validator(value) {
        return !isNaN(value) && value > 0;
      }
    },
    nombre: {
      type: String,
      default: '',
    },
    idFestejado: {
      type: Number,
      default: null,
    }
  },

  
  setup(props) {
    const errorMessage = ref('');
    const fileInput = ref(null);
    const selectedFiles = ref([]);
    const previewImages = ref([]);
    const photoUploaded = ref(false);
    const isLoading = ref(false);
    const lottieLoader = ref(null);
    const MAX_FILES = 10;


 // ✅ Cargar Lottie SOLO cuando `isLoading` cambia a `true`
 watch(isLoading, (newVal) => {
      if (newVal && lottieLoader.value) {
        console.log("🎬 Cargando animación Lottie...");
        lottie.loadAnimation({
          container: lottieLoader.value,
          renderer: 'svg',
          loop: true,
          autoplay: true,
          animationData: heartAnimation
        });
      }
    });

    const validateFiles = (event) => {
  const files = Array.from(event.target.files);
  
  if (files.length === 0) {
errorMessage.value = 'Please select at least one image.';
    return;
  }

  if (files.length > MAX_FILES) {
Swal.fire('Limit exceeded', `You can only upload a maximum of ${MAX_FILES} images.`, 'warning');
    event.target.value = ''; 
    return;
  }
  
  const invalidFiles = files.filter(file => !file.type.startsWith('image'));
  if (invalidFiles.length > 0) {
errorMessage.value = 'Please select only image files (JPG, PNG, GIF).';
    event.target.value = ''; // Limpia el input
    selectedFiles.value = [];
    previewImages.value = [];
  } else {
    errorMessage.value = '';
    selectedFiles.value = files;
    previewImages.value = selectedFiles.value.map(file => URL.createObjectURL(file));
  }
};


    const removeImage = (index) => {
      selectedFiles.value.splice(index, 1);
      previewImages.value.splice(index, 1);
    };

    const confirmUpload = async () => {
      if (selectedFiles.value.length === 0) {
errorMessage.value = 'Please select at least one image.';
        return;
      }

      Swal.fire({
      title: 'Review Your Photos',
text: 'Check the photo preview before uploading. Once you’re sure, click "Upload Photos".',
icon: 'info',
showCancelButton: true,
confirmButtonText: 'Upload Photos',
cancelButtonText: 'Cancel',

      }).then((result) => {
        if (result.isConfirmed) {
          uploadPhotos();
        }
      });
    };
    const uploadPhotos = async () => {
      console.log("🟢 Antes de activar loader:", isLoading.value);

      isLoading.value = true; // Activar el loader
      console.log("🟢 despues de activar loader:", isLoading.value);

  const formData = new FormData();
  selectedFiles.value.forEach(file => {
    formData.append('fotos', file);
  });

  formData.append('idFestejada', props.idFestejado);
  formData.append('idInvitado', props.idInvitado || null);

  // 🔍 Verificamos si las props tienen valores antes de construir la URL
  console.log("➡️ Valores recibidos en props:");
  console.log("🔹 Nombre:", props.nombre);
  console.log("🔹 idFestejado:", props.idFestejado);
  console.log("🔹 idInvitado:", props.idInvitado);

  try {
    // 🔍 Validar que los valores existan antes de armar la URL
    if (!props.nombre && !props.idFestejado && !props.idInvitado) {
      console.error(" ERROR: No se recibieron parámetros válidos.");
      return;
    }

    // 🔹 Construcción segura de la URL
    const params = [];
    if (props.nombre) params.push(encodeURIComponent(props.nombre));
    if (props.idFestejado) params.push(props.idFestejado);
    if (props.idInvitado) params.push(props.idInvitado);

    const paqueteUrl = `${baseUrl}/subirfotos/${params.join('/')}`;

    // 📌 Mostrar la URL final antes de enviar la petición
    console.log(" URL para subir fotos:", paqueteUrl);

    // 🔥 Verificamos qué se está enviando en formData
    for (let [key, value] of formData.entries()) {
      console.log(` FormData -> ${key}:`, value);
    }

    // 🔥 Hacemos la petición POST con Axios
    const response = await axios.post(paqueteUrl, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });

    console.log(" Respuesta del servidor:", response.data);

    if (response.data.success) {
Swal.fire('Success!', 'Your photos have been uploaded successfully.', 'success');
      photoUploaded.value = true;
      previewImages.value = [];
      selectedFiles.value = [];
      fileInput.value.value = '';  // Limpiar el input después de subir las fotos
    } else {
Swal.fire('Error', 'There was a problem uploading the photos.', 'error');
    }
  } catch (error) {
console.error('Error uploading photos:', error);
console.error('Error code:', error.code);
console.error('Server response:', error.response ? error.response.data : 'No response');

Swal.fire('Error', 'There was a problem uploading the photos.', 'error');

  }finally {
    isLoading.value = false; // Desactivar el loader después de la respuesta
  }
};



    return { 
      errorMessage, 
      fileInput, 
      confirmUpload, 
      validateFiles, 
      photoUploaded, 
      previewImages, 
      removeImage ,isLoading, lottieLoader 
    };
  }
};
</script>
  
  
  <style scoped>
  .container{
  min-height: 200px;
    height: auto;
  }
  .decorative-svg {
    position: absolute;
    top: 0;
    left: 50%; /* Mueve la imagen al centro */
    transform: translateX(-50%); /* Ajusta la posición exacta al centro */
    width: 60%;
    height: auto;
    margin-bottom: 20px;
  }
  
  .titulo{
  
   font-family: 'CynthiaJuneJF', cursive;
  font-size: 46px !important;
   background: linear-gradient(110deg, #e6a6c6 30%, #ff85ae 45%, #faadd8 50%, #ff85c2 55%, #ef90ae 70%);
  background-size: 200% auto;
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
  filter: drop-shadow(0px 2px 3px rgba(0,0,0,0.3));
  display: block; 
  }
  .upload-container {
    
    max-width: auto;
    margin: auto;
    border-radius: 15px;
  }
  
  /* Área de subida de fotos con borde punteado */
  .upload-area {
    border: 2px dashed #2b24174e;
    padding: 20px;
    text-align: center;
    cursor: pointer;
    border-radius: 10px;
    transition: all 0.3s ease;
  }
  
  .upload-area:hover {
    background: rgba(74, 144, 226, 0.1);
  }
  
  /* Ícono de cámara */
  .upload-icon {
    font-size: 40px;
    color: #2b2d2e79;
  }
  
  /* Vista previa de imágenes */
  .preview-grid {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
    justify-content: center;
  }
  
  .preview-item {
    position: relative;
    width: 100px;
    height: 100px;
    border-radius: 8px;
    overflow: hidden;
  }
  
  .preview-image {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  
  .delete-btn {
    position: absolute;
    top: 5px;
    right: 5px;
    background: red;
    color: white;
    border: none;
    border-radius: 50%;
    width: 20px;
    height: 20px;
    cursor: pointer;
  }
  .gif-pequeno {
    width: 50px; /* Ajusta el tamaño según tus necesidades */
    height: auto; /* Mantiene la proporción del GIF */
  }
  .file-input {
    background-color: white;
    color: white;
    border: none;
    width: 100px; /* Ajusta según necesites */
    height: 30px;
    opacity: 0.01; /* Casi invisible */
  }
  .upload-btn {
 background-image: url('@/assets/dorado.jpeg');
  background-size: cover;
  background-position: center;
  background-color: #bf953f; /* Respaldo */    color: white;
    font-size: 16px;
    font-weight: bold;
    padding: 12px 20px;
    justify-content: center;
    border: none;
    border-radius: 8px;
    cursor: pointer;
    transition: all 0.3s ease-in-out;
    display: flex;
    align-items: center;
    gap: 8px; /* Espacio entre el ícono y el texto */
    box-shadow: 0px 4px 10px rgba(225, 219, 220, 0.3);
  }
  
  .upload-btn:hover {
    background: linear-gradient(135deg, rgba(48, 73, 93, 1), rgba(74, 93, 107, 1));
    box-shadow: 0px 6px 15px rgba(255, 92, 148, 0.5);
  }
  
  .upload-btn i {
    font-size: 20px;
  }
  
  .loader-container {
    position: fixed; /* 🔥 Se fija en la pantalla sin importar el contenedor */
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%); /* 🔥 Centra el loader perfectamente */
    
    z-index: 10000 !important; /* Se asegura de estar por encima de todo */
  
    width: 100vw; /* 🔥 Ocupa todo el ancho de la pantalla */
    height: 100vh; /* 🔥 Ocupa todo el alto de la pantalla */
  
    background: rgba(0, 0, 0, 0.7); /* Fondo oscuro semitransparente */
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
  }
  
  
  
  
  .lottie-animation {
    width: 150px;
    height: 150px;
  }
  
  .loader-text {
    color: white;
    font-size: 20px;
    font-weight: bold;
    font-family: 'Dancing Script', cursive;
    margin-top: 15px;
  }
  
  </style>
  